import React, { useEffect, useState } from 'react';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getApiEndpoint } from '../../../../config/api';
import { getSettingsSection, saveSettingsSection } from '../../../../services/settingsService';

function CompanyInformation() {
  const [formData, setFormData] = useState({
    companyName: '',
    email: '',
    phone: '',
    address: '',
    logo: null
  });
  const [companyCode, setCompanyCode] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(getApiEndpoint('/api/users/profile'), {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) return;
        setFormData(prev => ({
          ...prev,
          companyName: data.companyName || '',
          email: data.email || '',
          phone: data.phoneNumber || ''
        }));
        if (data.companyCode) setCompanyCode(data.companyCode);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    getSettingsSection('company')
      .then((data) => {
        if (data && Object.keys(data).length > 0) {
          setFormData((prev) => ({ ...prev, ...data }));
        }
      })
      .catch(() => {});
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, logo: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        logo: formData.logo?.name || null
      };
      await saveSettingsSection('company', payload);
      toast.success('Company information saved');
    } catch (error) {
      toast.error(error.message || 'Failed to save company information', { autoClose: 4000 });
    }
  };

  const copyCode = () => {
    if (!companyCode) return;
    navigator.clipboard.writeText(companyCode).then(() => {
      toast.success('CloudSafe ID copied');
    }).catch(() => {});
  };

  return (
    <div className="stg-max-form">
      <div className="stg-page-header">
        <h1 className="stg-page-title">Company Information</h1>
        <p className="stg-page-subtitle">Manage your company details, logo and contact information.</p>
      </div>

      {companyCode && (
        <div className="stg-code-banner">
          <div className="stg-code-label">Your CloudSafe Company ID</div>
          <div className="stg-code-value">
            <span>{companyCode}</span>
            <button type="button" className="stg-code-copy" onClick={copyCode} title="Copy">
              <FaCopy />
            </button>
          </div>
          <p className="stg-code-hint">Share this ID with property owners so they can add your company as their management provider.</p>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="stg-section">
          <div className="stg-form-group">
            <label htmlFor="companyName" className="stg-form-label">Company Name</label>
            <input type="text" id="companyName" name="companyName" className="stg-input" value={formData.companyName} onChange={handleInputChange} required />
          </div>

          <div className="stg-form-group">
            <label htmlFor="logo" className="stg-form-label">Company Logo</label>
            <input type="file" id="logo" name="logo" className="stg-input stg-input-file" onChange={handleFileChange} accept="image/*" />
          </div>

          <div className="stg-form-group">
            <label htmlFor="email" className="stg-form-label">Contact Email</label>
            <input type="email" id="email" name="email" className="stg-input" value={formData.email} onChange={handleInputChange} required />
          </div>

          <div className="stg-form-group">
            <label htmlFor="phone" className="stg-form-label">Contact Phone</label>
            <input type="tel" id="phone" name="phone" className="stg-input" value={formData.phone} onChange={handleInputChange} required />
          </div>

          <div className="stg-form-group">
            <label htmlFor="address" className="stg-form-label">Company Address</label>
            <textarea id="address" name="address" className="stg-textarea" value={formData.address} onChange={handleInputChange} required />
          </div>
        </div>

        <div className="stg-actions" style={{ justifyContent: 'flex-start' }}>
          <button type="submit" className="stg-btn stg-btn-primary">Save Changes</button>
        </div>
      </form>
    </div>
  );
}

export default CompanyInformation;
